var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask"},[_c('div',{staticClass:"loading-box"},[_c('img',{staticClass:"gif-loading",attrs:{"src":`https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/130/gif_loading.gif`}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }